export const INPUT_NAME_PREFIX = "input_";
export const OUTPUT_NAME_PREFIX = "output_";
